import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const ABOUT_GROUP_PATHS = ['/about', '/news', '/roadmap'];

const Navbar = () => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Track if the main menu is open
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Track if the dropdown is open

  const isAboutGroupActive = ABOUT_GROUP_PATHS.includes(pathname);

  const closeMenus = () => {
    setIsMenuOpen(false); // Close the menu after a tab is clicked
    setIsDropdownOpen(false); // Close dropdown when a tab is clicked
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev); // Toggle main menu state
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev); // Toggle dropdown state
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <img src={`${process.env.PUBLIC_URL}/images/Logo_White_NB.png`} alt="PointeSense Logo" className="logo-image" />
          <span className="logo-text">
            <span className="pointe">Pointe</span>
            <span className="sense">Sense</span>
          </span>
        </div>
        <div className="nav-toggle" onClick={toggleMenu} id="nav-toggle">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`} id="nav-menu">
          <Link
            to="/"
            className={`nav-button ${pathname === '/' ? 'active' : ''}`}
            onClick={closeMenus}
          >
            Home
          </Link>
          <Link
            to="/how-it-works"
            className={`nav-button ${pathname === '/how-it-works' ? 'active' : ''}`}
            onClick={closeMenus}
          >
            How It Works
          </Link>
          <div className="nav-dropdown">
            <button
              className={`nav-button dropdown-button ${isAboutGroupActive ? 'active' : ''}`}
              onClick={toggleDropdown}
            >
              About
            </button>
            {isDropdownOpen && (
              <div className="dropdown-menu">
                <Link
                  to="/about"
                  className={`dropdown-item ${pathname === '/about' ? 'active' : ''}`}
                  onClick={closeMenus}
                >
                  About Us
                </Link>
                <Link
                  to="/news"
                  className={`dropdown-item ${pathname === '/news' ? 'active' : ''}`}
                  onClick={closeMenus}
                >
                  News
                </Link>
                <Link
                  to="/roadmap"
                  className={`dropdown-item ${pathname === '/roadmap' ? 'active' : ''}`}
                  onClick={closeMenus}
                >
                  Roadmap
                </Link>
              </div>
            )}
          </div>
          <Link
            to="/beta-testing"
            className={`nav-button ${pathname === '/beta-testing' ? 'active' : ''}`}
            onClick={closeMenus}
          >
            Beta Testing
          </Link>
          <Link
            to="/contact"
            className={`nav-button ${pathname === '/contact' ? 'active' : ''}`}
            onClick={closeMenus}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
